import { AppVersionApi } from "../api/app-version";
import { CardsApi } from "../api/cards";
import { CustomerCartApi } from "../api/customer-cart";
import { FeesApi } from "../api/fees";
import { GeoApi } from "../api/geo";
import { HostedEventsApi } from "../api/hosted-events";
import { InventoryApi } from "../api/inventory";
import { LiveApi } from "../api/live";
import { LocationsApi } from "../api/locations";
import { ScansApi } from "../api/scans";
import { SealedApi } from "../api/sealed";
import { ShopClaimsApi } from "../api/shop-claims";
import { ShopifyApi } from "../api/shopify";
import { ShopsApi } from "../api/shops";
import { StoreCustomersApi } from "../api/store-customers";
import { StoresApi } from "../api/stores";
import { StripeApi } from "../api/stripe";
import { UploadsApi } from "../api/uploads";
import { UserApi } from "../api/user";
import { VendorShowsApi } from "../api/vendor-shows";
import { Transport, type TransportConfig } from "../transport";

/** The merchant SPA's and the mobile app's view of the backend: a Firebase-signed-in user, their stores, scans and cards. */
export class MerchantClient {
  readonly user: UserApi;
  readonly appVersion: AppVersionApi;
  readonly stores: StoresApi;
  readonly scans: ScansApi;
  readonly cards: CardsApi;
  readonly sealed: SealedApi;
  readonly locations: LocationsApi;
  readonly events: HostedEventsApi;
  /** Other shops' card shows, and taking a table at one. */
  readonly shows: VendorShowsApi;
  readonly inventory: InventoryApi;
  readonly stripe: StripeApi;
  readonly customerCart: CustomerCartApi;
  readonly fees: FeesApi;
  readonly live: LiveApi;
  readonly shops: ShopsApi;
  readonly geo: GeoApi;
  readonly shopClaims: ShopClaimsApi;
  readonly uploads: UploadsApi;
  readonly shopify: ShopifyApi;
  readonly storeCustomers: StoreCustomersApi;

  constructor(cfg: TransportConfig) {
    const t = new Transport(cfg);
    this.user = new UserApi(t);
    this.appVersion = new AppVersionApi(t);
    this.stores = new StoresApi(t);
    this.scans = new ScansApi(t);
    this.cards = new CardsApi(t);
    this.sealed = new SealedApi(t);
    this.locations = new LocationsApi(t);
    this.events = new HostedEventsApi(t);
    this.shows = new VendorShowsApi(t);
    this.inventory = new InventoryApi(t);
    this.stripe = new StripeApi(t);
    this.customerCart = new CustomerCartApi(t);
    this.fees = new FeesApi(t);
    this.live = new LiveApi(t);
    this.shops = new ShopsApi(t);
    this.geo = new GeoApi(t);
    this.shopClaims = new ShopClaimsApi(t);
    this.uploads = new UploadsApi(t);
    this.shopify = new ShopifyApi(t);
    this.storeCustomers = new StoreCustomersApi(t);
  }
}
